import { Route, Switch } from 'react-router-dom';
import { StyledSubNavigation } from './styles';
import { subroutes, BILLING_VIEW_INVOICES_PATH } from './subroutes';
import { usePreReleaseFeatures } from 'hooks/usePreReleaseFeatures';
import { useMemo, useState } from 'react';
import { useBillingPermissions } from 'ts-components/hooks/permissions/billing';
import { SubNavWrapper } from '../../styled';

export default function BillingPage({ access, location }) {
  const preReleaseFeatures = usePreReleaseFeatures();
  const [invoiceSortOrder, setInvoiceSortOrder] = useState({
    column: 'created',
    direction: 'desc',
  });

  const routes = useMemo(() => {
    return subroutes(preReleaseFeatures);
  }, [preReleaseFeatures]);

  const billingPermission = useBillingPermissions();

  return (
    <>
      <SubNavWrapper>
        <StyledSubNavigation
          small
          id="sectionnav"
          routes={routes}
          currentSearch={location.search}
        />
      </SubNavWrapper>
      <Switch>
        {Object.entries(routes)
          .map(([key, route]) => {
            const Component = route.component;
            const hasPermission =
              route?.access?.checkBillingPermission?.(billingPermission);

            if (!hasPermission) {
              return null;
            }

            if (key === BILLING_VIEW_INVOICES_PATH) {
              return (
                <Route
                  key={key}
                  path={route.path}
                  exact={route.exact !== false}
                  component={route.component}
                >
                  <Component
                    access={access}
                    sortOrder={invoiceSortOrder}
                    setSortOrder={setInvoiceSortOrder}
                  />
                </Route>
              );
            }

            return (
              <Route
                key={key}
                path={route.path}
                exact={route.exact !== false}
                component={route.component}
              >
                <Component access={access} sortOrder={invoiceSortOrder} />
              </Route>
            );
          })
          .filter(Boolean)}
      </Switch>
    </>
  );
}
